import { Service } from 'src/types';
import CustomPageBlock, { PageBlockProps } from './page-block';
import ServiceCards from 'src/pages/services/cards/service-cards';
import { useNavigate } from 'react-router-dom';
import { SERVICES_ROUTES } from 'src/constants/routes';

export default function CustomPageServices({
  items,
  title,
  description,
  type,
  pages
}: Readonly<PageBlockProps<Service>>) {
  const navigate = useNavigate();

  const onServiceClick = (service: Partial<Service>) => service.url && navigate(service.url, { state: pages });

  return (
    <CustomPageBlock title={title} description={description} type={type} path={SERVICES_ROUTES[1].path}>
      <ServiceCards
        blockTitle={''}
        services={items}
        className={'startPage'}
        servicesLimit={5}
        showCardsPagination={true}
        onClick={onServiceClick}
      />
    </CustomPageBlock>
  );
}
